// Conjunto de fichas técnicas de una cotización, en un solo PDF (salto de página por ficha).
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { theme } from '../styles/theme';
import { FichaTecnica, FICHA_CSS } from './FichaTecnica';

export function FichasBundle() {
  const { id } = useParams<{ id: string }>();
  const [skus, setSkus] = useState<string[] | null>(null);

  useEffect(() => {
    (async () => {
      if (!id) return;
      const { data: items } = await supabase.from('quote_items').select('product_id, sku').eq('quote_id', id);
      const rows = (items as { product_id: string | null; sku: string | null }[]) ?? [];
      const pids = Array.from(new Set(rows.map(r => r.product_id).filter(Boolean))) as string[];
      let list: string[] = [];
      if (pids.length) {
        const { data: prods } = await supabase.from('products').select('sku').in('id', pids);
        list = ((prods as { sku: string }[]) ?? []).map(p => p.sku);
      }
      if (list.length === 0) list = Array.from(new Set(rows.map(r => r.sku).filter(Boolean))) as string[];
      setSkus(list);
      document.title = `Fichas tecnicas - Cotizacion ${(id || '').slice(0, 8)}`;
    })();
  }, [id]);

  if (skus === null) return <div style={{ padding: 40, fontFamily: theme.font.sans }}>Cargando fichas…</div>;
  if (skus.length === 0) return <div style={{ padding: 40, fontFamily: theme.font.sans }}>Esta cotización no tiene productos con ficha.</div>;

  return (
    <div>
      <style>{FICHA_CSS}</style>
      <div className="no-print" style={{
        background: theme.brand, color: 'white', padding: '14px 24px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: theme.font.sans,
      }}>
        <span style={{ fontSize: 13, fontWeight: 600 }}>{skus.length} ficha{skus.length > 1 ? 's' : ''} técnica{skus.length > 1 ? 's' : ''}</span>
        <button onClick={() => window.print()} style={{
          background: theme.accent, color: theme.brand, border: 'none', padding: '8px 18px',
          fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, cursor: 'pointer', fontFamily: theme.font.sans,
        }}>📥 Descargar todas (PDF)</button>
      </div>
      {skus.map((sku, i) => (
        <div key={sku} style={{ pageBreakAfter: i < skus.length - 1 ? 'always' : 'auto' }}>
          <FichaTecnica embedSku={sku} embedded />
        </div>
      ))}
    </div>
  );
}
